
export function getBadgesForProfile(profile) {
  if (!profile?.badges || !Array.isArray(profile.badges)) return [];

  return profile.badges.map((badge, index) => ({
    key: `${badge.game_name}_level_${badge.level}`,
    label: badge.game_name,
    image: badge.image || `/images/badges/${badge.game_name}_${badge.level}.png`,
    level: badge.level,
  }));
}